import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectorRef, HostListener } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';
import { PurchasingService } from '../../services/purchasing.service';
import { OrdersService } from '../../services/orders.service';
import { OmsService } from '../../services/oms.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { FormBuilder, FormControl, FormGroup, Validators, UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common'
import { PrintService } from '../../services/print.service'
import { UsersService } from 'app/services/users.service';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { GlobalsService } from 'app/services/globals.service';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';
import { VendorService } from 'app/services/vendor.service';
import { debounce, debounceTime, map, startWith } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';


@Component({
	selector: 'app-warehouse-stockcounts-scan',
	templateUrl: './warehouse-stockcounts-scan.component.html',
	styleUrls: ['./warehouse-stockcounts-scan.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		]),
	]
})
export class WarehouseStockcountsScanComponent implements OnInit {

	today = new Date();
	@ViewChild('count_table') printtable: ElementRef;
	@ViewChild('reviewComponent') reviewComponent: any;
	color: any = 'blue';

	@ViewChild('hiddenScanInput') hiddenScanInput: ElementRef;
	@ViewChild('barcodeScanner') barcodeScanner: BarcodeScannerLivestreamComponent;
	
	
	lastInputSelected: any = false;


	location: any = '';
	locations: any = [];
	suppliers: any = false;
	user: any = [];

	sheetForm: FormGroup;
	vendor_selected: any = false;
	sending = false;
	exporting = false;
	// counting_items: any =false;
	fetching = false;
	nil = new FormControl(false);
	flip = 'inactive';
	filename = 'StockCounts';
	stockCountsLink: any = false;
	config: any = false;

	isPosUser: any = false;
	savingCounts: any = false;
	counting_items: any = MatTableDataSource<any>;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable<any>;
	items_per_page = [50, 100, 250, 500];
	pagesizedefault = 100;

	limit_load: any = false;
	bincounted: any = false;

	filterview: Boolean = false;
	bins: any = [];
	binsFiltered: any = [];

	filters: any = {
		'location': '',
		'vendor': '',
		'category': '',
		'productline': ''
	}

	@ViewChild('changesModal') changesModalRef: ElementRef;


	firstload: any = true;
	mfgs: any = [];
	mfgnames: any = [];
	storeDiscardRequired = false;

	categories: any = [];
	categorynames: any = [];

	productlines: any = [];
	productlinenames: any = [];

	addToBinOption: any = false;
	filterPanelViewable: Boolean = false;

	lastItem: any = false;
	unfiltered_counts: any = false;

	showSave = false;
	itemsToSave: any = {};
	itemsToreview: any = [];



	CURRENT_MODE: any = 'BATCH';
	sheetsPrinting = false;
	selectingBin = false;

	myControl = new UntypedFormControl('');
	unfiltered_all_counts: any = [];

	allbins = true;




	#scanner
	selectedBin: any = false;
	// Core properties
	currentItem: any = null;
	scanMode: 'single' | 'bulk' = 'single';
	bulkQuantity = 0; // Quantity to record for bulk mode
	bulkQuantityInput = 0; // Input field for quantity
	isScanning = false;
	lastScanTime = 0;
	private timeUpdateInterval: any;
	lastSearchTerm: any = '';
	// Essential properties from warehouse-scaninout
	CHAT_ROOM = 'OrderBoard';
	qtyBin: UntypedFormControl = new UntypedFormControl({ value: 'RECDOC', disabled: true }, Validators.required);

	// Scan detail modal properties
	showScanDetailModal = false;
	selectedScanDetail: any = null;

	// Form controls
	scanForm: UntypedFormGroup;
	hiddenScanControl: UntypedFormControl = new UntypedFormControl('');
	qtyRec: UntypedFormControl = new UntypedFormControl(0, Validators.required);

	// Visual feedback
	scanStatus: 'idle' | 'success' | 'error' | 'warning' | 'processing' = 'idle';
	statusMessage = '';
	binLocation = '';


	// Barcode scanner
	useCameraScanner = false;


	// Search functionality
	searchInput = new UntypedFormControl('');
	searchResults: any[] = [];
	isSearchMode = false;
	showSearchResults = false;
	isMobile = false;

	// Add barcode functionality
	showBarcodeAddModal = false;
	showBarcodeAddForm = false;
	barcodeAddError = '';
	private originalMode: 'scan' | 'search' | null = null;

	// Bottom menu visibility control
	get shouldShowBottomMenu(): boolean {
		return !this.showBarcodeAddModal;
	}


	// Touch gesture support for bottom sheet
	private touchStartY = 0;
	private touchCurrentY = 0;
	private isDragging = false;

	// Keyboard listener control
	keyboardListenerEnabled = true;

	// Manager mode state memory
	private modeBeforeManager = false;

	// MST modal
	showMstModal = false;
	mstList: any[] = [];
	loadingMstData = false;
	mstToggle: FormControl = new FormControl(false); // false = receive, true = send

	// Advanced controls drawer
	showAdvancedDrawer = false;

	// Vendor PO display
	showVendorPoTable = false;
	vendorPoDetails: any[] = [];

	// Warehouse properties (from warehouse-scaninout)
	receiving_quantity = 0;
	receiving_bin = 'RECDOC';
	expected: any = false;
	already_scanned: any = 0;
	scan_history: any = false;
	private hadScansBeforeRefresh = false;
	token: any = false;


	// Core receiving functionality

	qtyAdded = false;
	showScanHistory = false;

	// Vendor management
	selectedVendor: any = null; // No default vendor - user must select
	availableVendors: any[] = [];
	showVendorButtons = false;

	// Purchase order integration
	purchaseOrders: any = null;
	expectedQuantity = 0;
	loadingPurchaseOrders = false;

	// Send/Receive toggle and RGA support
	sendToggle: UntypedFormControl = new UntypedFormControl(false);
	vendorRgas: any = null;

	// Item details for warehouse-scaninout component
	itemDetailsForScaninout: any = null;

	// MST support (handled by warehouse-scaninout component)
	mstdetails: any = null;

	// UI state
	showDetails = false; // Hidden by default
	undoingLast = false;
	// Feature flags / UI toggles
	showResetControls = false; // Hidden: reset will be triggered via payload later

	// Purchase history (from warehouse-scaninout)
	history: any = false;
	historyloading = false;

	// Enhanced scan capture
	public keyBuffer = '';
	private readonly MIN_BARCODE_LENGTH = 4; // Minimum barcode length
	private readonly MAX_BARCODE_LENGTH = 50; // Maximum barcode length

	// Memory leak prevention - subscription tracking
	private subscriptions: Subscription[] = [];
	private timeouts: any[] = [];
	private intervals: any[] = [];
	private resizeListener: (() => void) | null = null;

	// Socket connection status
	socketConnected = false;
	socketStatusMessage = 'Connecting...';

	autosave = false;
	lastbinupdate: any = false;


	@ViewChild('trigger', { read: MatAutocompleteTrigger }) autocompleteTrigger: MatAutocompleteTrigger;


	


	constructor(private formBuilder: UntypedFormBuilder, private locationService: Location, private vendorService: VendorService, private cdr: ChangeDetectorRef, private globalsService: GlobalsService, private cd: ChangeDetectorRef, private usersService: UsersService, public printService: PrintService, public lLoaction: Location, private fb: FormBuilder, private route: ActivatedRoute, public router: Router, private modalService: NgbModal, private omsService: OmsService, private globalSearchService: GlobalSearchService, private inventoryService: InventoryService, public ordersService: OrdersService, public purchasingService: PurchasingService) {
		this.color = this.globalSearchService.getColor();

		this.usersService.isPosUser().subscribe((isPOS: any) => {
			this.isPosUser = isPOS;

			isPOS ? this.limitLocations() : ''
		})

		this.globalSearchService.user.subscribe((u: any) => {
			this.user = u;
			this.location = u.user.defaultlocation.loccode
		});
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.mesagesallowed.next(false);
		this.token = this.globalSearchService.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyz');
		this.omsService.setupSocketConnection(this.token);
	}


	ngOnInit(): void {

		this.globalsService.getLocations().subscribe((results: any) => {
			this.locations = results;
			if (results.length) {
				this.limitLocations();
			}
		});

		this.purchasingService.getSuppliers('').subscribe((results: any) => {
			this.suppliers = results;
		})

		//load filters
		this.setForm();

		//scanner
		// Detect mobile device
		this.detectMobile();

		// Load vendors
		this.loadVendors();

		if (this.CURRENT_MODE == 'BIN') {
			this.statusMessage = 'Waiting for BIN scan...'
		} else {
			this.toggleSearchMode();
			this.statusMessage == 'FREE EDIT MODE...'
		}

		// Start socket status monitoring
		this.startSocketStatusMonitoring();


		//perform search - on empty input reset filtered values
		this.searchInput.valueChanges.pipe(debounceTime(500)).subscribe((newV) => {
			if (newV == '') {
				const updateQtys = this.itemsToSaveCount()
				this.unfilterCounts(updateQtys);
				if ((this.selectedBin) && this.CURRENT_MODE == 'FREE') {
					this.updateActiveBin([{ bin: this.selectedBin }], this.selectedBin);
				}
				this.statusMessage = 'Ready to search'
			}
		})

		//bin search autocomplete
		this.binsFiltered = this.myControl.valueChanges.pipe(
			startWith(''),
			map(value => this._filter(value || '')),
		);

	}

	private _filter(value: string): string[] {
		const filterValue = value.toLowerCase();
		return this.bins.filter(option => option.toLowerCase().includes(filterValue));
	}

	ngOnDestroy(): void {
		// Cleanup time update interval
		this.stopTimeUpdateInterval();

		// Cleanup all subscriptions
		this.subscriptions.forEach(subscription => {
			if (subscription && !subscription.closed) {
				subscription.unsubscribe();
			}
		});
		this.subscriptions = [];

		// Cleanup all timeouts
		this.timeouts.forEach(timeoutId => {
			clearTimeout(timeoutId);
		});
		this.timeouts = [];

		// Cleanup all intervals
		this.intervals.forEach(intervalId => {
			clearInterval(intervalId);
		});
		this.intervals = [];

		// Cleanup window resize event listener
		if (this.resizeListener) {
			window.removeEventListener('resize', this.resizeListener);
			this.resizeListener = null;
		}
	}

	ngAfterViewInit(): void {
		// Force readonly on hidden input to prevent keyboard
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.setAttribute('readonly', 'readonly');
			this.hiddenScanInput.nativeElement.setAttribute('inputmode', 'none');
		}

		// Focus scanner input after view init to prepare for scanning
		setTimeout(() => {
			this.focusScannerInput();
		}, 100);
	}

	@HostListener('document:keydown', ['$event'])
	onDocumentKeyDown(event: KeyboardEvent): void {
		const target = event.target as HTMLElement;


		// Allow normal input in search mode for search input fields
		if (this.isSearchMode && (
			target.classList.contains('search-input-field') ||
			target.classList.contains('mat-input-element') ||
			target.tagName === 'INPUT' ||
			target.tagName === 'TEXTAREA'
		)) {
			return; // Don't prevent default behavior for search inputs
		}

		// Allow normal input when barcode add form is displayed
		if (this.showBarcodeAddForm) {
			return; // Don't prevent default behavior - allow all keyboard input
		}

		// Skip keyboard listener if disabled
		if (!this.keyboardListenerEnabled) {
			return;
		}

		// Handle barcode scanner input FIRST - build buffer but don't process until Enter
		// Only build buffer in scanner mode, not search mode
		if (event.key.length === 1 && this.isValidScanCharacter(event.key) && !this.isSearchMode) {
			this.keyBuffer += event.key;
			this.isScanning = true;
			// Prevent default behavior to avoid keyboard popup
			event.preventDefault();
			return; // Don't process yet, just build buffer
		}

		// Handle Enter key - process complete barcode (barcode scanner completion)
		// Only process in scanner mode, not search mode
		if (event.key === 'Enter' && !this.isSearchMode) {
			event.preventDefault();
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}

		// Handle Escape key - clear buffer
		if (event.key === 'Escape') {
			this.clearScanBuffer();
		}
	}

	onHiddenInputFocus(): void {
		// Immediately blur to prevent keyboard popup
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.blur();
		}
	}

	onHiddenInputKeyDown(event: KeyboardEvent): void {
		// Only handle Enter key, let other keys pass through to document listener
		if (event.key === 'Enter') {
			event.preventDefault();
			// Use the keyBuffer instead of the form control value to avoid conflicts
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}
	}

	// Override any focus events that might trigger keyboard
	@HostListener('focusin', ['$event'])
	onFocusIn(event: FocusEvent): void {
		const target = event.target as HTMLElement;
		// Only allow focus on specific safe elements
		if (!this.isSafeFocusTarget(target)) {
			event.preventDefault();
			event.stopPropagation();
			(event.target as HTMLElement).blur();
		}
	}

	private isSafeFocusTarget(element: HTMLElement): boolean {
		// Allow focus only on buttons, mat-button-toggle, and input fields in appropriate modes
		return element.tagName === 'BUTTON' ||
			element.classList.contains('mat-button-toggle-button') ||
			// Allow scanner input to be focusable for mobile tap functionality
			element.classList.contains('scanner-input') ||
			(this.isSearchMode && (
				element.classList.contains('search-input-field') ||
				element.classList.contains('search-button') ||
				element.classList.contains('mat-input-element') ||
				element.tagName === 'INPUT' ||
				element.tagName === 'TEXTAREA'
			));
	}

	//   onQuantityInputFocus(): void {
	// 	// For quantity input, we actually want the keyboard to show
	// 	// since users need to type numbers, but we can add any special handling here
	//   }

	/**
	 * Solution 3: Camera-based barcode scanner
	 * Alternative input method that doesn't require keyboard
	 */
	//   onBarcodeScanned(barcode: string): void {

	// 	this.processScanInput(barcode);
	//   }

	//   onScannerStarted(started: boolean): void {
	// 	// Handle scanner started event if needed
	//   }

	// ENHANCED SCAN CAPTURE METHODS

	private isValidScanCharacter(key: string): boolean {
		// Allow alphanumeric characters, common barcode symbols, and special characters
		return /^[a-zA-Z0-9\-_\.\+\*\#\@\$\%\&\=\!\?\(\)\[\]\{\}\|\\\/\:\;\<\>\,\~\`\s]$/.test(key);
	}


	private clearScanBuffer(): void {
		this.keyBuffer = '';
		this.isScanning = false;
	}


	//   private showScanError(message: string): void {
	// 	this.scanStatus = 'error';
	// 	this.statusMessage = message;
	// 	this.playWarningSound();

	// 	// Clear error after 3 seconds
	// 	const timeoutId = setTimeout(() => {
	// 	  if (this.scanStatus === 'error') {
	// 		this.scanStatus = 'idle';
	// 		this.statusMessage = '';
	// 	  }
	// 	}, 3000);
	// 	this.timeouts.push(timeoutId);
	//   }

	//   private showVendorRequiredError(): void {
	// 	this.scanStatus = 'error';
	// 	this.statusMessage = '⚠️ VENDOR REQUIRED - Please select a vendor first!';
	// 	this.playBuzzerSound();
	// 	this.vibrateDevice();

	// 	// Clear error after 4 seconds (longer for important message)
	// 	const timeoutId = setTimeout(() => {
	// 	  if (this.scanStatus === 'error') {
	// 		this.scanStatus = 'idle';
	// 		this.statusMessage = '';
	// 	  }
	// 	}, 4000);
	// 	this.timeouts.push(timeoutId);
	//   }

	//   private showScanWarning(message: string): void {
	// 	this.scanStatus = 'warning';
	// 	this.statusMessage = message;

	// 	// Clear warning after 2 seconds
	// 	const timeoutId = setTimeout(() => {
	// 	  if (this.scanStatus === 'warning') {
	// 		this.scanStatus = 'idle';
	// 		this.statusMessage = '';
	// 	  }
	// 	}, 2000);
	// 	this.timeouts.push(timeoutId);
	//   }


	storeCurrentCounts() {
		this.unfiltered_counts = JSON.parse(JSON.stringify(this.counting_items.data));
	}


	//auto save for one off counts
	updateLocalCount(update) {

		this.counting_items.data.forEach((local) => {
			if (local.stockid == update.stockid && local.bin == update.bin) {
				const newcount = update.counted ?? 0;
				local.counted = newcount >= 0 ? newcount : 0;
				local.time = update.time;
				local.user = update.user;
				local.hasbeencounted = true;
				local.saving = false;
			}
		})


		//update main count obj
		this.unfilterCounts();
	}


	updateActiveBin(bins, searchedFor) {
		if (bins.length == 1) {
			this.storeCurrentCounts();
			this.selectedBin = bins[0].bin;

			const items = this.counting_items.data.filter((i) => i.bin == this.selectedBin);
			this.setPagination(items);


			this.bincounted = true;
			items.forEach((row) => {
				if(!this.lastbinupdate || (new Date(row.time) > new Date(this.lastbinupdate) )){
					this.lastbinupdate = { 'time' : row?.time, 'user': row?.user };
				}
				if (!row.time?.length || !row.user?.length) {
					this.bincounted = false;
				}
			})


			document.getElementById('scan-box').scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			})

			this.clearScanBuffer();
			this.clearCurrentItem();
			this.isScanning = false;
			this.scanStatus = 'idle';
			this.statusMessage = 'Waiting for Item Scan...';

			if (this.searchInput.value && !this.isMobile) {
				this.performSearch();
			}
		} else {
			this.scanStatus = 'warning';
			this.isScanning = false;
			this.statusMessage = `BIN ${searchedFor} not found`;
		}
	}

	// CORE SCANNING LOGIC

	private processScanInput(barcode: string): void {
		if (!barcode || barcode.trim() === '') {return;}

		// Basic validation - only check for reasonable length and non-empty
		const trimmed = barcode.trim();
		if (trimmed.length < 1 || trimmed.length > 100) {
			//   this.showScanError('Invalid barcode format. Please try again.');
			this.clearScanBuffer();
			return;
		}

		// Update last scan time
		this.lastScanTime = Date.now();
		this.startTimeUpdateInterval();

		// Clear any existing item before processing new scan and store in last
		if (this.currentItem) {
			const last = this.currentItem.stockid;
			this.lastItem = last;
		}
		this.clearCurrentItem();

		this.isScanning = true;
		this.scanStatus = 'processing';
		this.statusMessage = 'Processing scan...';



		//select bin
		if (this.counting_items?.data?.length) {
			if (!this.selectedBin) {
				const data = { 'bin': barcode.trim(), 'loccode': '01', 'anybin': true };
				this.inventoryService.getBinSearch(data).subscribe((bins) => {
					this.updateActiveBin(bins, barcode.trim());
				})
			} else {
				this.lookupVersionEight(barcode.trim());
			}
		} else {
			this.globalSearchService.showNotification('Search discarded, counts loading..', 'warning', 'top', 'left');
			if (!this.selectedBin) {
				this.isScanning = false;
				this.scanStatus = 'idle';
				this.statusMessage = 'Waiting for bin scan...';
			} else {
				this.isScanning = false;
				this.scanStatus = 'idle';
				this.statusMessage = 'Waiting for item scan...';
			}

		}

	}

	//   private validateBarcode(barcode: string): boolean {
	// 	// Basic barcode validation
	// 	const trimmed = barcode.trim();

	// 	// Check length
	// 	if (trimmed.length < this.MIN_BARCODE_LENGTH || trimmed.length > this.MAX_BARCODE_LENGTH) {
	// 	  return false;
	// 	}

	// 	// Check for valid characters (alphanumeric and common barcode symbols)
	// 	if (!/^[a-zA-Z0-9\-_\.\+\*\#\@\$\%\&\=\!\?\(\)\[\]\{\}\|\\\/\:\;\<\>\,\~\`]+$/.test(trimmed)) {
	// 	  return false;
	// 	}

	// 	// Check for common barcode patterns
	// 	const commonPatterns = [
	// 	  /^[A-Z]{2,4}-\d{6,12}$/, // SKU pattern like ADV-1951340505
	// 	  /^\d{8,14}$/, // Numeric barcodes
	// 	  /^[A-Z0-9]{8,20}$/, // Alphanumeric codes
	// 	];

	// 	return commonPatterns.some(pattern => pattern.test(trimmed));
	//   }

	private lookupVersionEight(barcode: string): void {
		// Use the same search method as warehouse-item-scan-two
		const searchData = { stockid: barcode };

		const itemSearchSubscription = this.inventoryService.itemSearch(searchData).subscribe({
			next: (results: any) => {
				this.handleScanResults(results, barcode);
			},
			error: (error) => {
				this.handleScanError(error, barcode);
			}
		});
		this.subscriptions.push(itemSearchSubscription);
	}


	addItemToBin(proceed) {
		//need to push to stockcheckfreeze, stockcounts?
		if (!proceed) {
			this.addToBinOption = false;
			this.statusMessage = 'Waiting for item scan...';
			this.scanStatus = 'idle';
			return;
		}

		const item = {
			stockid: this.currentItem.stockid,
			qoh: 0,
			originalcounted: 0,
			counted: 1,
			description: this.currentItem.description,
			bin: this.selectedBin,
			partno: this.currentItem.stockid,
			vendor: 'idk',
			loccode: this.sheetForm.get('location').value,
			fakeline: 'NEW'
		}
		this.currentItem['newToBin'] = true;


		const new_arr_with_item = [...this.counting_items.data, item];
		this.setPagination(new_arr_with_item);

		const countkey = item.bin + item.stockid;
		this.itemsToSave[countkey] = item;

		this.addToBinOption = false;
		this.scanStatus = 'success';
		this.statusMessage = `${this.currentItem.stockid} added to ${this.selectedBin}`

		this.scrollToActive(item.stockid, this.counting_items.data.length);

		setTimeout(() => {
			document.getElementById('scan-box').scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			})
		}, 500)


		this.addToBinOption = false;
		this.scanStatus = 'success';
		this.statusMessage = `${this.currentItem.stockid} added to ${this.selectedBin}`
		this.isScanning = false;
	}



	private pageupdate() {
		this.paginator.page.emit({
			pageIndex: this.paginator.pageIndex,
			pageSize: this.paginator.pageSize,
			length: this.paginator.length
		});
	}

	private scrollToActive(id, currentIndex) {


		this.paginator.pageIndex = this.currentItem['newToBin'] ? Math.floor(this.paginator.length / this.paginator.pageSize) : Math.floor(currentIndex / this.paginator.pageSize);
		delete (this.currentItem['newToBin']);
		this.pageupdate();

		document.getElementById('toptable').scrollIntoView({ block: 'start' });
		document.getElementById('scan-box').scrollIntoView({ block: 'start' })
		document.getElementById('toptable').scrollIntoView({ block: 'start' });

		//only could get 7 to display horizontally on phone ? stupid fix for jumps :(
		if (this.counting_items.data.length > 7) {

			if (currentIndex > 7) {
				setTimeout(() => {
					document.getElementById(id).scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					})
				}, 200)
			} else {
				// setTimeout(()=>{
				// 	document.getElementById(id).scrollIntoView({
				// 		behavior: 'smooth',
				// 		block: 'start',								
				// 	})
				// },200)
			}


		}
	}

	private handleScanResults(results: any, barcode: string): void {
		this.isScanning = false;

		if (results && results.length > 0) {
			const item = results[0];
			this.currentItem = item;

			if (this.scanMode === 'single') {
				//update counted quantity for item here
				//save on bin completion or by item?
				let match = false;


				let index = 0;
				this.counting_items.data.forEach((prod) => {
					index++;
					if (prod.stockid == this.currentItem.stockid && prod.bin == this.selectedBin) {
						prod.counted = Number(prod.counted) + 1;
						this.currentItem.counted = prod.counted;
						match = true;
						this.audioPlay();
						this.statusMessage = 'Waiting for Item Scan...';

						if (this.autosave) {
							prod.saving = true;
							this.saveFreeCounts([prod]);
						} else {
							const countkey = prod.bin + prod.stockid;
							this.itemsToSave[countkey] = prod;
						}

						if (this.lastItem != this.currentItem.stockid) {
							this.scrollToActive(prod.stockid, index);
						}
						this.scanStatus = 'idle';
					}
				})

				if (!match) {
					this.scanStatus = 'warning';
					this.addToBinOption = true;
					this.playWarningSound();
					this.statusMessage = `No match for: ${item.description} in ${this.selectedBin}? Add to bin?`;
				}
			}

			// Scroll to result after successful scan
			this.scrollToScanResult();

		} else {
			// Item not found - show modal with add barcode option
			this.searchResults = []; // Clear search results so modal content shows
			this.scanStatus = 'warning';
			this.statusMessage = '🔍 ITEM NOT FOUND - Barcode not in system';
			this.lastSearchTerm = barcode;
			this.showBarcodeAddForm = false;
			this.originalMode = 'scan';
			// Play different buzzer sound for item not found
			this.playItemNotFoundBuzzer();
			this.vibrate();
		}
	}

	private handleScanError(error: any, barcode: string): void {
		this.isScanning = false;
		this.scanStatus = 'error';
		this.statusMessage = 'Scan error occurred';
		this.audioPlayBad();
		this.vibrate();
	}



	// Audio context management
	private audioContext: AudioContext | null = null;

	private getAudioContext(): AudioContext {
		if (!this.audioContext) {
			this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
		}
		return this.audioContext;
	}

	private audioPlay(): void {
		// Play success sound using Web Audio API
		try {
			const audioContext = this.getAudioContext();
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();

			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);

			// Success sound: pleasant beep
			oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
			oscillator.frequency.setValueAtTime(1000, audioContext.currentTime + 0.1);

			oscillator.type = 'sine';
			gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
			gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.3);
		} catch (error) {
			console.warn('Success sound failed:', error);
		}
	}

	private audioPlayBad(): void {
		// Play error sound using Web Audio API
		try {
			const audioContext = this.getAudioContext();
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();

			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);

			// Error sound: harsh buzz
			oscillator.frequency.setValueAtTime(200, audioContext.currentTime);
			oscillator.frequency.setValueAtTime(150, audioContext.currentTime + 0.1);
			oscillator.frequency.setValueAtTime(200, audioContext.currentTime + 0.2);

			oscillator.type = 'square';
			gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
			gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.5);
		} catch (error) {
			console.warn('Error sound failed:', error);
		}
	}

	playSuccessSound(): void {
		this.audioPlay();
	}

	playWarningSound(): void {
		this.audioPlayBad();
	}

	playBuzzerSound(): void {
		// Play a more aggressive buzzer sound for vendor requirement
		try {
			// Create a buzzer-like sound using Web Audio API
			const audioContext = this.getAudioContext();
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();

			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);

			// Buzzer sound: low frequency, harsh tone
			oscillator.frequency.setValueAtTime(200, audioContext.currentTime);
			oscillator.frequency.setValueAtTime(150, audioContext.currentTime + 0.1);
			oscillator.frequency.setValueAtTime(200, audioContext.currentTime + 0.2);

			oscillator.type = 'square'; // Harsh square wave
			gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
			gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.5);
		} catch (error) {
			// Fallback to existing warning sound if Web Audio API fails
			console.warn('Buzzer sound failed, using fallback:', error);
			this.audioPlayBad();
		}
	}

	playItemNotFoundBuzzer(): void {
		// Play a different buzzer sound for item not found
		try {
			// Create a different buzzer pattern using Web Audio API
			const audioContext = this.getAudioContext();
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();

			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);

			// Different buzzer pattern: higher frequency, more "beep beep beep" pattern
			oscillator.frequency.setValueAtTime(400, audioContext.currentTime);     // First beep
			oscillator.frequency.setValueAtTime(0, audioContext.currentTime + 0.1); // Silence
			oscillator.frequency.setValueAtTime(400, audioContext.currentTime + 0.2); // Second beep
			oscillator.frequency.setValueAtTime(0, audioContext.currentTime + 0.3); // Silence
			oscillator.frequency.setValueAtTime(400, audioContext.currentTime + 0.4); // Third beep

			oscillator.type = 'sine'; // Softer sine wave for different tone
			gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
			gainNode.gain.setValueAtTime(0, audioContext.currentTime + 0.1);
			gainNode.gain.setValueAtTime(0.2, audioContext.currentTime + 0.2);
			gainNode.gain.setValueAtTime(0, audioContext.currentTime + 0.3);
			gainNode.gain.setValueAtTime(0.2, audioContext.currentTime + 0.4);
			gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.7);

			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.7);
		} catch (error) {
			// Fallback to existing warning sound if Web Audio API fails
			console.warn('Item not found buzzer failed, using fallback:', error);
			this.audioPlayBad();
		}
	}

	playDestinationAudio(destination: string): void {
		// Play audio based on destination type
		let audioFile = '';

		switch (destination) {
		case 'stock':
			audioFile = '/assets/stock.mp3';
			break;
		case 'staging':
			audioFile = '/assets/staging.mp3';
			break;
		case 'sticker':
			audioFile = '/assets/sticker.mp3';
			break;
		case 'notonpo':
			// Use error sound for items not on PO
			audioFile = '/assets/overrec.mp3';
			break;
		case 'nopo':
			audioFile = '/assets/nopo.mp3';
			break;
		default:
			// Default to stock sound
			audioFile = '/assets/stock.mp3';
			break;
		}


		if (audioFile) {
			const audio = new Audio(audioFile);

			audio.volume = 0.9;
			// Add event listeners for debugging
			audio.addEventListener('error', (e) => console.error('Audio error:', audioFile, e));

			audio.play().catch(e => {
				// Fallback to existing audio if destination audio fails
				this.audioPlay();
			});
		}
	}

	private playAudioForScannedItem(stockid: string): void {
		// Get destination information for the scanned item
		const data = {
			stockid: stockid,
			loccode: this.location,
			vendor: this.vendor_selected
		};

		const itemDestinationSubscription = this.inventoryService.getItemDestination(data).subscribe({
			next: (result: any) => {
				const scannedQty = parseInt(result.scannedQty) || 0;
				const expectedQty = parseInt(result.expectedQty) || parseInt(result.stats?.openpos) || 0;

				// Determine audio destination based on business rules

				this.playDestinationAudio(null);
			},
			error: (error) => {
				// Default to stock sound if destination lookup fails
				this.playDestinationAudio('stock');
			}
		});
		this.subscriptions.push(itemDestinationSubscription);
	}


	vibrateDevice(): void {
		this.vibrate();
	}

	private vibrate(): void {
		if (window.navigator && window.navigator.vibrate) {
			navigator.vibrate(2000);
		} else {
			// Not supported
		}
	}

	goBack(): void {
		this.locationService.back();
	}

	clearCurrentItem(): void {
		//copy prev item
		this.currentItem = null;
		this.itemDetailsForScaninout = null; // Clear item details
		this.scanStatus = 'idle';
		this.statusMessage = '';
		this.binLocation = '';
		this.bulkQuantity = 0;
		this.bulkQuantityInput = 0;
		this.showDetails = false; // Hide details when clearing item
	}


	private sanitizeNumber(x: any): number {
		if (Number.isNaN(x)) {
			x = 0;
		}
		return parseFloat(Number.parseFloat(x).toFixed(0));
	}

	loadVendors(): void {
		const loadVendorsSubscription = this.vendorService.getVendors().subscribe((vendors: any) => {
			this.availableVendors = vendors.filter((v: any) => v.bankref !== '');
			
		});
		this.subscriptions.push(loadVendorsSubscription);
	}


	onFocusSearch(event: any): void {
		// Handle focus search event from warehouse-scaninout
		if (event.searching) {
			this.clearCurrentItem();
		}
	}


	updateQty(value: any, event: any): void {
		if (value == '') {
			event.stopPropagation();
			event.preventDefault();
			return;
		}

		this.receiving_quantity = parseFloat(value);
		this.qtyRec.setValue(this.receiving_quantity);
	}

	// KEYBOARD LISTENER CONTROL METHODS

	toggleKeyboardListener(): void {
		this.keyboardListenerEnabled = !this.keyboardListenerEnabled;
		this.globalSearchService.showNotification(
			`Keyboard listener ${this.keyboardListenerEnabled ? 'enabled' : 'disabled'}`,
			'info',
			'top',
			'left'
		);
	}

	enableKeyboardListener(): void {
		this.keyboardListenerEnabled = true;
	}

	disableKeyboardListener(): void {
		this.keyboardListenerEnabled = false;
	}

	// SEARCH FUNCTIONALITY METHODS

	toggleSearchMode(): void {
		this.isSearchMode = !this.isSearchMode;
		this.cdr.detectChanges();

		if (this.isSearchMode) {
			// Entering search mode - disable keyboard listener and clear scanner state
			this.disableKeyboardListener();
			this.clearSearchResults();

			// Focus on search input after a short delay to ensure DOM is updated
			const timeoutId = setTimeout(() => {
				this.focusInlineSearchInput();
			}, 100);
			this.timeouts.push(timeoutId);
		} else {
			// Exiting search mode - enable keyboard listener
			this.enableKeyboardListener();
			this.clearSearchResults();
			// Blur any focused input to prevent keyboard popup
			this.blurAllInputs();

			if (this.isMobile && this.CURRENT_MODE != 'BIN') {
				this.resetBinSelection();
				this.searchInput.setValue('');
				if (this.isMobile) {
					this.itemsToSave = {}
				}
			}

			// take values from filtered search list and update counts
			this.unfilterCounts()


			// Focus scanner input to prepare for scanning
			setTimeout(() => {
				this.focusScannerInput();
			}, 100);
		}
	}

	unfilterCounts(updateQty = true) {
		if (this.unfiltered_all_counts && updateQty) {
			this.unfiltered_all_counts = this.unfiltered_all_counts.map(unfiltered => {
				//look for match by bin and stockid
				const match = this.counting_items?.data?.find(filtered =>
					filtered.stockid === unfiltered.stockid && filtered.bin === unfiltered.bin
				);

				// unpack match and overide counted
				if (match) {
					return { ...unfiltered, counted: match.counted };
				}


				return unfiltered;
			});

			//check if item is new
			this.counting_items?.data?.forEach((viewingItem) => {
				const match = this.unfiltered_all_counts.find(unfiltered =>
					unfiltered.stockid === viewingItem.stockid && unfiltered.bin === viewingItem.bin
				);

				//add new item to main obj 
				if (!match) {
					this.unfiltered_all_counts.push({ ...viewingItem });
				}
			})
		}
	

		const search = this.searchInput.value.trim().toLowerCase();

		if (search.length) {
			const possibleMatches = this.unfiltered_all_counts.filter((item) => {
				if (item.description.toLowerCase().includes(search) || item.stockid.toLowerCase().includes(search) || this.hasBarcodeMatch(item, search) || item.bin.toLowerCase().trim().includes(search)) {
					if (this.selectedBin && this.selectedBin != 'ALL') {
						if (item.bin.toUpperCase() == this.selectedBin.toUpperCase()) {
							return item;
						}
					} else {
						return item;
					}
				}
			})

			this.setPagination(possibleMatches);
			this.handleSearchResults(possibleMatches);
		} else {
			if (this.selectedBin) {
				this.setPagination(this.unfiltered_all_counts.filter((o) => o.bin == this.selectedBin));
			} else {
				this.setPagination(this.unfiltered_all_counts);
			}
		}
	}

	// Mobile-specific search toggle
	onMobileScannerInputTap(): void {
		if (this.isMobile && !this.keyBuffer) {
			// Only toggle to search mode if we're on mobile and no barcode is being scanned
			this.toggleSearchMode();
		}
	}

	private focusInlineSearchInput(): void {
		const searchInput = document.querySelector('.search-input-field') as HTMLInputElement;
		if (searchInput) {
			searchInput.focus();
		}
	}

	private focusScannerInput(): void {
		// Focus on the hidden scan input to prepare for barcode scanning
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.focus();
		}
	}

	private scrollToScanResult(): void {
		// Scroll to the scan result after a brief delay to ensure DOM is updated
		setTimeout(() => {
			// Try to find the scan result element (minimal scan card or bulk mode card)
			const scanResultElement = document.querySelector('.minimal-scan-card, .bulk-mode-card');

			if (scanResultElement) {
				scanResultElement.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest'
				});
			} else {
				// Fallback: scroll to the top of the card body
				const cardBody = document.querySelector('.card-body');
				if (cardBody) {
					cardBody.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'nearest'
					});
				}
			}
		}, 300); // Delay to allow DOM updates and animations to complete
	}

	private blurAllInputs(): void {
		const inputs = document.querySelectorAll('input, textarea');
		inputs.forEach((input: any) => {
			if (input !== document.activeElement) {
				input.blur();
			}
		});
	}


	hasBarcodeMatch(item, search) {
		let match = [];
		if (item.barcodes) {
			match = item.barcodes.filter((i) => {

				let hasmatch = false;
				switch (true) {
				case i.toUpperCase() === search.toUpperCase():
					hasmatch = true;
					break;
				case i.slice(-12).toUpperCase() === search.slice(-12).toUpperCase():
					hasmatch = true;
					break;
				case i.slice(0, 12).toUpperCase() === search.slice(0, 12).toUpperCase():
					hasmatch = true;
					break;
				}
				if (hasmatch) {
					return i;
				}
			});
		}
		return match.length ? true : false;
	}


	changeCountMode(current) {
		//change count mode
		this.CURRENT_MODE = current == 'BIN' ? 'FREE' : 'BIN';

		//remove last item
		this.currentItem = false;

		//reset counts back to unfiltered state
		if (this.CURRENT_MODE == 'FREE') {

			// this.resetBinSelection();
			if (!this.isSearchMode) {
				this.toggleSearchMode();
			}
		} else {
			// this.resetBinSelection();
			if (this.isSearchMode) {
				this.toggleSearchMode();
			}
		}

		this.scrollToActive(null, 0);

	}

	performSearch(): void {
		if (!this.searchInput.value || this.searchInput.value.trim() === '') {
			this.globalSearchService.showNotification('Please enter a search term', 'warning', 'top', 'left');
			return;
		}

		this.isScanning = true;
		this.scanStatus = 'idle';
		this.statusMessage = 'Searching...';

		const searchData = { stockid: this.searchInput.value.trim() };
		const search = this.searchInput.value.trim().toLowerCase();


		//bin mode is by batch or with auto save those are sent off and upadted locally as they're updated 
		if (this.CURRENT_MODE != 'BIN') {
			const updateQtys = this.itemsToSaveCount();
			this.unfilterCounts(updateQtys)
		}

		const possibleMatches = this.counting_items.data?.filter((item) => {
			if (item.description.toLowerCase().includes(search) || item.stockid.toLowerCase().includes(search) || this.hasBarcodeMatch(item, search) || item.bin.toLowerCase().trim().includes(search)) {
				// with bin active
				if (this.selectedBin && this.selectedBin != '' && item.bin.toUpperCase() == this.selectedBin.toUpperCase()) {
					return item;
				}

				//with 'empty' bin selection
				if (this.selectedBin == '' && item.bin == '') {
					return item;
				}

				//ALL
				if (!this.selectedBin) {
					return item;
				}
			}
		})

		//reset page to zero on data found
		if (possibleMatches.length) {
			this.paginator.pageIndex = 0;
		}


		this.handleSearchResults(possibleMatches)
	}

	private handleSearchResults(results: any): void {
		this.isScanning = false;
		this.scanStatus = 'idle';
		this.statusMessage = '';

		if (results.length) {
			this.storeCurrentCounts();
			this.searchResults = results;


			//need to filter out results that aren't in current data set?

			if (results.length === 1) {
				// Auto-select single result with brief delay for user feedback
				this.scanStatus = 'success';
				this.statusMessage = 'Found 1 item, selecting...';

				// Brief delay to show the found item before auto-selecting
				const timeoutId = setTimeout(() => {
					this.selectSearchResult(results);
					this.scanStatus = 'success';
					this.statusMessage = 'Item selected';
				}, 800);
				this.timeouts.push(timeoutId);
			} else {
				// Show multiple results
				this.selectSearchResult(results);
				this.scanStatus = 'success';
				this.statusMessage = `Found ${results.length} items`;
			}
		} else {
			// No search results found - show modal with add barcode option
			this.searchResults = [];
			this.scanStatus = 'warning';
			this.statusMessage = '🔍 NO ITEMS FOUND - Search returned no results';
			this.lastSearchTerm = this.searchInput.value;

			// Store original mode (search mode)
			this.originalMode = 'search';

			// Disable keyboard capture during barcode add process
			this.disableKeyboardListener();

			// Play different buzzer sound for no search results
			this.playItemNotFoundBuzzer();
		}
	}

	selectSearchResult(items: any) {
		const copy = JSON.parse(JSON.stringify(this.counting_items.data));
		this.setPagination(items);
		return copy;
	}

	clearSearchResults(): void {
		this.searchResults = [];
		this.showSearchResults = false;
	}

	// LAST SCAN TIME DISPLAY

	getLastScanTimeDisplay(): string {
		if (!this.lastScanTime) {
			return 'No scans yet';
		}

		const now = Date.now();
		const diffMs = now - this.lastScanTime;
		const diffSeconds = Math.floor(diffMs / 1000);
		const diffMinutes = Math.floor(diffSeconds / 60);
		const diffHours = Math.floor(diffMinutes / 60);

		if (diffSeconds < 60) {
			return `${diffSeconds}s ago`;
		} else if (diffMinutes < 60) {
			return `${diffMinutes}m ago`;
		} else if (diffHours < 24) {
			return `${diffHours}h ago`;
		} else {
			const date = new Date(this.lastScanTime);
			return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
		}
	}

	private startTimeUpdateInterval(): void {
		// Clear existing interval
		if (this.timeUpdateInterval) {
			clearInterval(this.timeUpdateInterval);
			// Remove from tracking array
			const index = this.intervals.indexOf(this.timeUpdateInterval);
			if (index > -1) {
				this.intervals.splice(index, 1);
			}
		}

		// Start new interval to update display every second
		this.timeUpdateInterval = setInterval(() => {
			if (this.lastScanTime) {
				// Use setTimeout to defer change detection and avoid ExpressionChangedAfterItHasBeenCheckedError
				const timeoutId = setTimeout(() => {
					this.cdr.detectChanges();
				}, 0);
				this.timeouts.push(timeoutId);
			}
		}, 1000);

		// Track the interval
		this.intervals.push(this.timeUpdateInterval);
	}

	private stopTimeUpdateInterval(): void {
		if (this.timeUpdateInterval) {
			clearInterval(this.timeUpdateInterval);
			// Remove from tracking array
			const index = this.intervals.indexOf(this.timeUpdateInterval);
			if (index > -1) {
				this.intervals.splice(index, 1);
			}
			this.timeUpdateInterval = null;
		}
	}

	// MOBILE DETECTION

	private detectMobile(): void {
		// Check if device is mobile based on screen width and user agent
		this.isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		// Listen for window resize to update mobile detection
		this.resizeListener = () => {
			this.isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if (this.isMobile) {
				this.CURRENT_MODE = 'BIN'
			} else {
				this.CURRENT_MODE = 'FREE';
			}
		};

		if (this.isMobile) {
			this.CURRENT_MODE = 'BIN'
		} else {
			this.CURRENT_MODE = 'FREE';
		}
		window.addEventListener('resize', this.resizeListener);
	}

	// STATE MANAGEMENT METHODS

	resetToScannerMode(): void {
		// Reset all search-related state
		this.isSearchMode = false;
		this.clearSearchResults();

		// Reset modal states
		this.showMstModal = false;
		this.mstList = [];

		// Reset vendor PO display
		this.showVendorPoTable = false;
		this.vendorPoDetails = [];

		// Enable keyboard listener
		this.enableKeyboardListener();

		// Clear any focused inputs
		this.blurAllInputs();

		this.globalSearchService.showNotification('Reset to Scanner Mode', 'info', 'top', 'left');
	}

	resetAllState(): void {
		// Clear current item and all related data
		this.clearCurrentItem();

		// Reset search state
		this.clearSearchResults();
		this.isSearchMode = false;

		// Reset modal states
		this.showMstModal = false;
		this.mstList = [];

		// Reset vendor PO display
		this.showVendorPoTable = false;
		this.vendorPoDetails = [];

		// Reset scan mode to single
		this.scanMode = 'single';

		// Reset bulk quantities
		this.bulkQuantity = 0;
		this.bulkQuantityInput = 0;


		// Enable keyboard listener
		this.enableKeyboardListener();

		// Clear any focused inputs
		this.blurAllInputs();

		// Reset scan status
		this.scanStatus = 'idle';
		this.statusMessage = '';

		this.globalSearchService.showNotification('All state reset', 'info', 'top', 'left');
	}




	onModeChange(): void {
		// Clear current item when switching modes
		this.clearCurrentItem();
		this.scanStatus = 'idle';
		this.statusMessage = '';

		// Clear search state
		this.clearSearchResults();
	}



	// SOCKET STATUS MONITORING

	private startSocketStatusMonitoring(): void {
		// Check socket status immediately
		this.updateSocketStatus();

		// Check socket status every 5 seconds
		const statusInterval = setInterval(() => {
			this.updateSocketStatus();
		}, 5000);
		this.intervals.push(statusInterval);
	}

	private updateSocketStatus(): void {
		if (this.omsService.socket) {
			const connectionState = this.omsService.getConnectionState();
			this.socketConnected = this.omsService.isSocketHealthy();

			switch (connectionState) {
			case 'connected':
				this.socketStatusMessage = 'Connected';
				break;
			case 'connecting':
				this.socketStatusMessage = 'Connecting...';
				break;
			case 'disconnected':
				this.socketStatusMessage = 'Disconnected';
				break;
			case 'error':
				this.socketStatusMessage = 'Connection Error';
				break;
			default:
				this.socketStatusMessage = 'Unknown';
			}
		} else {
			this.socketConnected = false;
			this.socketStatusMessage = 'No Socket';
		}
	}

	getSocketStatusClass(): string {
		if (this.socketConnected) {
			return 'socket-status-connected';
		} else {
			return 'socket-status-disconnected';
		}
	}

	getSocketStatusIcon(): string {
		if (this.socketConnected) {
			return 'wifi';
		} else {
			return 'wifi_off';
		}
	}

	// Allow manual reconnection
	reconnectSocket(): void {
		if (this.omsService) {
			this.omsService.forceReconnect();
			this.updateSocketStatus();
		}
	}



	initialLoad(interactedWith = false) {
		if (this.firstload) {
			this.sheetForm = this.fb.group({
				keywords: [''],
				location: [this.locations[0].loccode, Validators.required],
				vendor: [this.sheetForm, Validators.required],
				category: [''],
				lineid: [''],
				stockid: [''],
			});
			this.firstload = false;
		}

		this.setPagination([]);

		this.fetching = true;

		this.inventoryService.getCurrentCountsScan(this.sheetForm.value).subscribe(r => {

			this.fetching = false;
			if (r.success) {
				this.bins = this.buildBinList(r.items);
				this.setPagination(r.items)
				this.storeCurrentCounts();
				this.unfiltered_all_counts = r.items;
			} else {
				this.globalSearchService.showNotification(r.message, 'danger', 'bottom', 'right');
				this.openFilterPanel();
				
				if(!this.firstload && interactedWith){
					this.createLoadSheets();
				}
			}
		})
	}


	buildBinList(item_array){
		return [...new Set(item_array.map((i) => { return i.bin }))] ?? [];
	}



	limitLocations() {
		if (this.isPosUser && this.locations.length) {
			this.locations = this.locations.filter((loc) => loc.loccode == this.user.user.defaultlocation.loccode)
			this.initialLoad();
		} else {
			this.initialLoad();
		}
	}


	resetSheets(event: any) {
		if (event) {
			this.counting_items = false;
			this.fetching = false;
			this.flip = 'inactive';
		}
	}

	binSelectionMode() {
		this.selectingBin = !this.selectingBin;
		if (this.selectingBin) {
			this.disableKeyboardListener();
			setTimeout(() => {
				this.autocompleteTrigger.openPanel()
				document.getElementById('bininput').focus();
			}, 250);
		}
	}

	selectBin() {
		this.allbins = false;
		this.enableKeyboardListener();
		this.bincounted = false;
		if (this.myControl.value == 'ALL') {
			this.resetBinSelection();
			this.allbins = true;
			if (this.searchInput.value) {
				this.performSearch();
			}
		} else {
			const bin = this.bins.find((bin) => bin.toUpperCase() == this.myControl.value.toUpperCase());
			if (bin || bin == '') {
				if (this.selectedBin || bin == '') {
					this.resetBinSelection();
				}
				this.updateActiveBin([{ bin: bin }], this.myControl.value);
			}
		}

		this.selectingBin = false;
		this.myControl.setValue('');
	}

	pdfLink() {
		this.sheetsPrinting = true;
		this.inventoryService.printCountSheets(this.sheetForm.value).subscribe((res) => {
			this.sheetsPrinting = false;
		})
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}


	setForm() {
		function label(input, haystack, mobile) {
			let out = '';
			const haystackReversed = Object.fromEntries(
				Object.entries(haystack).map(([key, value]) => [value, key])
			);

			if (mobile) {
				out = haystack[input] ? `${haystackReversed[haystack[input]]}` : '';
			} else {
				out = haystack[input] ? `${haystackReversed[haystack[input]]}: ${haystack[input]}` : '';
			}
			return out;
		}

		this.purchasingService.getSuppliers('').subscribe((res: any) => {
			if (res.length) {
				this.mfgs = res.map((mfg) => {
					this.mfgnames[mfg.supplierid] = mfg.suppname;
					return { 'view': mfg.suppname, 'value': mfg.supplierid }
				});
				this.sheetForm.get('vendor').valueChanges.subscribe((newV) => {
					this.filters.vendor = label(newV, this.mfgnames, this.isMobile);
				})
			}
		})
		this.inventoryService.getItemCategories().subscribe((res: any) => {
			if (res.length) {
				this.categories = res.map((cat) => {
					this.categorynames[cat.categoryid] = cat.categorydescription;
					return { 'view': cat.categorydescription, 'value': cat.categoryid }
				});
				this.sheetForm.get('category').valueChanges.subscribe((newV) => {
					this.filters.category = label(newV, this.categorynames, this.isMobile);
				})
			}
		})

		this.inventoryService.getItemProductlines().subscribe((res: any) => {
			if (res.length) {
				this.productlines = res.map((line) => {
					this.productlinenames[line.line_field] = line.line_description;
					return { 'view': line.line_description, 'value': line.line_field }
				});
				this.sheetForm.get('lineid').valueChanges.subscribe((newV) => {
					this.filters.productline = label(newV, this.productlinenames, this.isMobile);
				})
			}
		})
	}

	clearFilters() {
		this.sheetForm.get('category').setValue('');
		this.sheetForm.get('lineid').setValue('');
		this.sheetForm.get('vendor').setValue('');
	}

	createLoadSheets() {
		this.fetching = true;
		const data = this.sheetForm.value;
		data.user = this.user.user.userid;
		data.ispos = this.isPosUser;
		data.scanner = true;

		this.inventoryService.createLoadSheetsScan(data).subscribe((r: any) => {
			this.fetching = false;
			if (r.success) {
				this.bins = [...new Set(r.items.map((i) => { return i.bin }))] ?? [];
				this.setPagination(r.items);
				this.unfiltered_all_counts = r.items;
			} else {
				this.globalSearchService.showNotification(r.message, 'danger', 'bottom', 'right');
			}
		});
	}

	
	private qtyTimers = new Map<any, any>();
	debounceQty(event: Event, item: any) {
		if (this.qtyTimers.has(item)) {
			clearTimeout(this.qtyTimers.get(item));
		}
		const timer = setTimeout(() => {
			this.setQty(event, item);
		}, 500);

		this.qtyTimers.set(item, timer);
	}


	setQty(event: any, item: any) {
		let val = parseFloat(event.target.value);
		if (isNaN(val)) {
			val = 0;
		}
		item.counted = val;
		this.currentItem = item;

		if (this.autosave) {
			item.saving = true;
			this.saveFreeCounts([item]);
		} else {
			if (this.CURRENT_MODE == 'FREE') {
				//check if it exists in items to save
				const countkey = item.bin + item.stockid;
				this.itemsToSave[countkey] = item;
			}
		}
	}

	selectInput(item){
		this.lastInputSelected = item.bin + item.stockid + '-input';
		const ele: any = document.getElementById(this.lastInputSelected)
		ele.select();
	}


	updateCurrentCount(amt, item) {
		this.counting_items.data.map((prod) => {
			if (prod.stockid == item.stockid && prod.bin == this.selectedBin) {
				const newcount = (prod.counted += amt);
				prod.counted = newcount >= 0 ? newcount : 0;
				this.currentItem.counted = prod.counted;
				prod.time = item.time;
				prod.user = item.user;
			}
		})
	}

	itemsToSaveCount() {
		return Object.keys(this.itemsToSave).length ? true : false;
	}

	resetCount(item) {
		if (this.currentItem && item.stockid == this.currentItem.stockid && item.bin == this.currentItem.bin) {
			this.currentItem = false;
		}
		item.counted = item.originalcounted ?? 0;
		delete (this.itemsToSave[item.bin + item.stockid]);
	}


	saveBinCounts(reload: any = false) {
		//this function takes the on screen bin filtered down counts and pushes them into stockcounts: ZEROES ARE INCLUDED IN THE COUNTS
		if (this.savingCounts) {
			this.savingCounts.unsubscribe();
		}

		const data = this.counting_items.data.map((row) => {
			row.user = this.user.user.userid;
			return row;
		})

		this.savingCounts = this.inventoryService.saveCountsScan(data).subscribe(r => {
			this.savingCounts = false;
			if (r.success) {
				this.globalSearchService.showNotification(r.msg, 'success', 'bottom', 'left');
			} else {
				this.globalSearchService.showNotification(r.msg, 'danger', 'bottom', 'left');
			}
		})

		if (reload) {
			this.initialLoad();
		}
	}

	saveFreeCounts(items, flip: any = false) {
		if (items.length) {
			const data = items.map((row) => {
				row.user = this.user.user.userid;
				return row;
			})

			this.savingCounts = this.inventoryService.saveCountsScan(data).pipe(debounceTime(500)).subscribe(r => {
				this.savingCounts = false;
				this.itemsToSave = {};

				this.modalService.dismissAll();

				if (!this.autosave) {
					this.searchInput.setValue('');
					this.initialLoad();
				} else {
					//find current item
					this.updateLocalCount(r.update[0].value);
				}

				if (r.success) {
					this.globalSearchService.showNotification(r.msg, 'success', 'bottom', 'left');
					if (flip) {
						this.toggleFlip();
					}
				} else {
					this.globalSearchService.showNotification(r.msg, 'danger', 'bottom', 'left');
				}
			});
		} else {
			this.globalSearchService.showNotification('Discarding edits', 'warn', 'bottom', 'left');
			this.modalService.dismissAll();
		}
	}


	toggleFlip() {
		if (this.itemsToSaveCount()) {
			const save = confirm('Save current changes? \n\n(cancel will discard current edits)')
			if (save) {
				this.saveFreeCounts(Object.values(this.itemsToSave), 'flip');
			} else {
				this.resetAllCountChanges();
				this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
			}
		} else {
			this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
		}
	}



	resetAllCountChanges() {
		const items_to_reset = Object.values(this.itemsToSave);
		(items_to_reset).forEach((item) => {
			this.resetCount(item);
		})
	}

	back(): void {
		this.lLoaction.back()
	}


	setPagination(tableData) {
		this.counting_items = new MatTableDataSource<any>(tableData);
		this.counting_items.paginator = this.paginator;
		this.dataObs = this.counting_items.connect();
		this.cd.detectChanges();

		//no counts loaded => open filters
		if (!tableData.length) {
			// this.openFilterPanel();
		} else {
			this.closeFilterPanel();
		}



		//RE-FOCUS LAST FOCUSED INPUT ELEMENT IF AVAIL
		if(this.lastInputSelected){
			const ele:any = document.getElementById(this.lastInputSelected);
			if(ele){
				ele.focus();
				ele.select()
			}
		}
		

		//neeeded?	
		// if (this.currentItem) {
		// 	setTimeout(() => {
		// 		// this.scrollToActive(this.currentItem.stockid , 999);
		// 	}, 500);
		// }
	}

	preventTab(ev, item){
		if(item.saving && ev.key === ('Tab' || 'tab')){
			ev.preventDefault();
			ev.stopPropagation();
		}
	}

	toggleAutoSave() {
		this.autosave = !this.autosave;
		if (this.itemsToSaveCount() && this.autosave) {
			this.storeDiscardRequired = true;
			this.completeEditedItems();
		}
	}

	discardBatchEdits() {
		this.itemsToreview.forEach((item) => {
			this.resetCount(item)
		})
		this.modalService.dismissAll();
	}


	openFilterPanel() {
		if (!this.filterPanelViewable) {
			this.filterPanelViewable = true;
		}
	}

	closeFilterPanel() {
		if (this.filterPanelViewable) {
			this.filterPanelViewable = false;
		}
	}


	resetBinSelection() {
		//this is them saying no and don't commit counts
		this.selectedBin = false;
		this.currentItem = false;
		this.isScanning = false;
		this.scanStatus = 'idle';
		this.statusMessage = 'Waiting for bin scan...';
		const updateQty = this.itemsToSaveCount();
		this.unfilterCounts(updateQty);
	}

	completeEditedItems() {
		this.itemsToreview = Object.values(this.itemsToSave);

		const cleanup = (() => {
			this.itemsToreview = [];
			//if they switched to autosave mid edits and bailed on the modal - reset back out of autosave mode
			if (this.storeDiscardRequired && this.itemsToSaveCount() && this.autosave) {
				this.autosave = false;
				this.storeDiscardRequired = false;
			}
		}).bind(this);


		//open modal to review all changes?
		this.modalService.open(this.changesModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
			cleanup();
		}).catch((reason) => {
			cleanup();
		});

		return;
	}

	completeBinSelection() {
		if (confirm(`Save ${this.selectedBin} counts?`)) {
			this.saveBinCounts('reload')
			this.selectedBin = false;
		}
		this.selectedBin = false;

		this.isScanning = false;
		this.scanStatus = 'idle';
		this.statusMessage = 'Awaiting bin scan...';
	}


	closeCounts() {
		if(this.reviewComponent) {
			this.reviewComponent.closeCounts();
		}
		setTimeout(() => {
			this.initialLoad();
		}, 1000)
	}

}
